var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a, _b, _c, _d, _e, _f;
/* eslint-disable camelcase */
import { suctionCupsFamilyDCF } from "./cup-families";
import { glassObjectShapes, suctionCupModelsGlass } from "./glass";
import { metalObjectShapes, suctionCupModelsMetal } from "./metal";
import { suctionCupModelsPlastic, plasticObjectShapes } from "./plastic";
import { cardboardObjectShapes, suctionCupModelsCardboard } from "./cardboard";
import { Material, } from "3d/types";
import { TubeType, GripPositionMarkerId, ObjectShapeId as MetalObjectShapeId, TubeConnectionId, } from "store/types";
/* GRIP POSITION */
export var defaultOvalGripPositionDiameterRatio = 2.5; // An oval grip position is considered 2.5 times as wide as it is high
export var ovalGrip3DModelDiameterRatio = 2; // the ratio of the 3D-model for the grip position differs from the desired ratio, so we need to take this into account when scaling the model
export var gripPositionMarkerDefaultWidth = (_a = {},
    _a[GripPositionMarkerId.CIRCLE] = 0.1,
    _a[GripPositionMarkerId.OVAL] = 0.06 * defaultOvalGripPositionDiameterRatio,
    _a);
export var gripPositionMarkerAssetScale = 0.1;
export var gripPositionMarkerMaterial = "TransparentDarkBlue";
/* Pumps and tube connections with nothing picked yet are drawn as their
 * toolbar icons in grey on camera-facing squares, as big on screen as a new
 * grip position's marker (see `sizeAsIfAtHeight`). */
export var placeholderIconSize = gripPositionMarkerDefaultWidth[GripPositionMarkerId.CIRCLE];
export var cupPlaceholderUp = "Placeholder-Fitting";
export var fittingPlaceholderTube = "Placeholder-Attachment";
export var defaultSuctionCupModel = __assign({}, suctionCupsFamilyDCF.DCF);
export var suctionCupModels = __assign(__assign(__assign(__assign({}, suctionCupModelsPlastic), suctionCupModelsGlass), suctionCupModelsMetal), suctionCupModelsCardboard);
export var gripPositionMarkerModels = (_b = {},
    _b[GripPositionMarkerId.CIRCLE] = {
        id: GripPositionMarkerId.CIRCLE,
        translationKey: "edit_grip_position.markers.circle",
        image: "img/app/circle-marker-white.svg",
        imageActive: "img/app/circle-marker-green.svg",
        modelName: "CupAreaCircle10cm",
        diameterRange: [0.002, 0.4],
    },
    _b[GripPositionMarkerId.OVAL] = {
        id: GripPositionMarkerId.OVAL,
        translationKey: "edit_grip_position.markers.oval",
        image: "img/app/oval-marker-width-height-white.svg",
        imageActive: "img/app/oval-marker-width-height-green.svg",
        modelName: "CupAreaOval5x10cm",
        diameterRange: [0.002, 0.4],
    },
    _b);
/* CUP MOUNTING */
export var cupMountingModels = {
    // Height adjuster 3/8
    cup_mounting_0121122: "0121122",
    // Height adjuster HA12
    cup_mounting_0200461: "0200461",
    // Height adjuster HA16
    cup_mounting_0200462: "0200462",
    // Level Compensator KSPH 3/8 fem 75mm, non rotate
    cup_mounting_0208930: "0208930",
    // Level Compensator KSPH 3/8 fem 50mm, non rotate
    cup_mounting_0208928: "0208928",
    // Level Compensator KSPH 3/8 fem 25mm, non rotate
    cup_mounting_0208926: "0208926",
    // Level Compensator LC25-80 3/8 fem
    cup_mounting_0124961: "0124961",
    // Level Compensator LC25-40 3/8 fem
    cup_mounting_0124959: "0124959",
    // Level Compensator LC12-10mm fem M5
    cup_mounting_0127103: "0127103",
    // Level Compensator LC12-25mm fem M5
    cup_mounting_0127105: "0127105",
    // Level Compensator LC16-20mm fem G1/8
    cup_mounting_0124951: "0124951",
    // Level Compensator LC16-35mm fem G1/8
    cup_mounting_0124953: "0124953",
    // Suction cup extension 200
    cup_mounting_0110663: "0110663",
    // Suction cup extension 150
    cup_mounting_0110661: "0110661",
    // Suction cup extension 110
    cup_mounting_0110659: "0110659",
    // Suction cup extension 75
    cup_mounting_0110657: "0110657",
    // Suction cup extension 50
    cup_mounting_0110655: "0110655",
    // Suction cup extension 25
    cup_mounting_0110653: "0110653",
    // Suction cup extension SE12
    cup_mounting_0200458: "0200458",
    // Suction cup extension SE16
    cup_mounting_0200459: "0200459",
    // Ball Joint fitting lockable (PMAT)
    cup_mounting_0110636: "0110636",
    // Ball Joint fitting (PMAT)
    cup_mounting_0110635: "0110635",
    // FSCM profile 200 18mm fem3/8
    cup_mounting_fscm_profile_200: "FSCMP18200G38FG38M",
    // FSCM profile 140 18mm fem3/8
    cup_mounting_fscm_profile_140: "FSCMP18140G38FG38M",
    // FSCM profile 110 18mm fem3/8
    cup_mounting_fscm_profile_110: "FSCMP18110G38FG38M",
    // FSCM profile 80 18mm fem3/8
    cup_mounting_fscm_profile_80: "FSCMP1880G38FG38M",
    // FSCM profile 45 18mm fem3/8
    cup_mounting_fscm_profile_45: "FSCMP1845G38FG38M",
    // FSCM Ball Joint 200 18mm fem3/8
    cup_mounting_fscm_ball_joint_200: "FSCMI18200G38FG38M",
    // FSCM Ball Joint 140 18mm fem3/8
    cup_mounting_fscm_ball_joint_140: "FSCMI18140G38FG38M",
    // FSCM Ball Joint 110 18mm fem3/8
    cup_mounting_fscm_ball_joint_110: "FSCMI18110G38FG38M",
    // FSCM Ball Joint 80 18mm fem3/8
    cup_mounting_fscm_ball_joint_80: "FSCMI1880G38FG38M",
    // FSCM Ball Joint 45 18mm fem3/8
    cup_mounting_fscm_ball_joint_45: "FSCMI1845G38FG38M",
    // Inline vacuum filter 50um (piSAFE version)
    cup_mounting_0232709: "0232709",
    // Extension kit G3/8" 100mm
    cup_mounting_0223743: "0223743",
    // Extension kit G3/8" 200mm
    cup_mounting_0223744: "0223744",
};
export var fittingPlaceholderCupMounting = "Placeholder-Attachment";
export var cupMountingPlaceholderTube = "Placeholder-Attachment";
/* TUBE CONNECTION */
export var toolChangerDefaultLength = 0.05; //50mm
export var tubeConnectionDefaultDiameter = 0.006;
export var tubeConnectionDefaultDiameterRange = [
    0.004, 0.016,
];
export var tubeConnectionMaterialAreaName = "MA_Tubing";
export var tubeConnectionModels = (_c = {},
    _c[TubeConnectionId.THREE_WAY_T] = {
        id: TubeConnectionId.THREE_WAY_T,
        translationKey: "sidebar.edit_tube_connection.connection_point_types.three_way_t",
        modelName: "Coupling-3T",
        placeholderNames: [
            "Placeholder-TubeBack",
            "Placeholder-TubeLeft",
            "Placeholder-TubeRight",
        ],
        isDouble: false,
        diameterRange: tubeConnectionDefaultDiameterRange,
        type: "tube-connection",
    },
    _c[TubeConnectionId.THREE_WAY_Y] = {
        id: TubeConnectionId.THREE_WAY_Y,
        translationKey: "sidebar.edit_tube_connection.connection_point_types.three_way_y",
        modelName: "Coupling-3Y",
        placeholderNames: [
            "Placeholder-TubeBack",
            "Placeholder-TubeLeft",
            "Placeholder-TubeRight",
        ],
        isDouble: false,
        diameterRange: tubeConnectionDefaultDiameterRange,
        type: "tube-connection",
    },
    _c[TubeConnectionId.TWO_WAY_90] = {
        id: TubeConnectionId.TWO_WAY_90,
        translationKey: "sidebar.edit_tube_connection.connection_point_types.two_way_90",
        modelName: "Coupling-2turn90",
        placeholderNames: ["Placeholder-TubeBack", "Placeholder-TubeLeft"],
        isDouble: false,
        diameterRange: tubeConnectionDefaultDiameterRange,
        type: "tube-connection",
    },
    _c[TubeConnectionId.FOUR_WAY_X] = {
        id: TubeConnectionId.FOUR_WAY_X,
        translationKey: "sidebar.edit_tube_connection.connection_point_types.four_way_x",
        modelName: "Coupling-4X",
        placeholderNames: [
            "Placeholder-TubeBack",
            "Placeholder-TubeFront",
            "Placeholder-TubeLeft",
            "Placeholder-TubeRight",
        ],
        isDouble: false,
        diameterRange: tubeConnectionDefaultDiameterRange,
        type: "tube-connection",
    },
    _c[TubeConnectionId.FOUR_WAY_TT] = {
        id: TubeConnectionId.FOUR_WAY_TT,
        translationKey: "sidebar.edit_tube_connection.connection_point_types.four_way_tt",
        modelName: "Coupling-4TT",
        placeholderNames: [
            "Placeholder-TubeBack",
            "Placeholder-TubeFront",
            "Placeholder-TubeLeftBack",
            "Placeholder-TubeLeftFront",
        ],
        isDouble: true,
        diameterRange: tubeConnectionDefaultDiameterRange,
        type: "tube-connection",
    },
    _c[TubeConnectionId.FOUR_WAY_TT_ALTERNATE] = {
        id: TubeConnectionId.FOUR_WAY_TT,
        translationKey: "sidebar.edit_tube_connection.connection_point_types.four_way_tt_alternate",
        modelName: "Coupling-4TTalternate",
        placeholderNames: [
            "Placeholder-TubeBack",
            "Placeholder-TubeFront",
            "Placeholder-TubeLeft",
            "Placeholder-TubeRight",
        ],
        isDouble: true,
        diameterRange: tubeConnectionDefaultDiameterRange,
        type: "tube-connection",
    },
    _c[TubeConnectionId.FOUR_WAY_TT_ALTERNATE_MIRROR] = {
        id: TubeConnectionId.FOUR_WAY_TT_ALTERNATE_MIRROR,
        translationKey: "sidebar.edit_tube_connection.connection_point_types.four_way_tt_alternate_mirror",
        modelName: "Coupling-4TTalternateMirrored",
        placeholderNames: [
            "Placeholder-TubeBack",
            "Placeholder-TubeFront",
            "Placeholder-TubeLeft",
            "Placeholder-TubeRight",
        ],
        isDouble: true,
        diameterRange: tubeConnectionDefaultDiameterRange,
        type: "tube-connection",
    },
    _c[TubeConnectionId.ONE_FOUR_FIVE_DISTRIBUTION_BLOCK] = {
        id: TubeConnectionId.ONE_FOUR_FIVE_DISTRIBUTION_BLOCK,
        translationKey: "sidebar.edit_tube_connection.connection_point_types.".concat(TubeConnectionId.ONE_FOUR_FIVE_DISTRIBUTION_BLOCK),
        modelName: "VacuumDistributionManifold-1-4-5",
        placeholderNames: [
            "Placeholder-TubeBack",
            "Placeholder-TubeFront",
            "Placeholder-TubeLeft1",
            "Placeholder-TubeLeft2",
            "Placeholder-TubeRight1",
            "Placeholder-TubeRight2",
        ],
        type: "distribution-block",
        volume_dm3: 0.012,
    },
    _c[TubeConnectionId.ONE_SIX_SEVEN_DISTRIBUTION_BLOCK] = {
        id: TubeConnectionId.ONE_SIX_SEVEN_DISTRIBUTION_BLOCK,
        translationKey: "sidebar.edit_tube_connection.connection_point_types.".concat(TubeConnectionId.ONE_SIX_SEVEN_DISTRIBUTION_BLOCK),
        modelName: "VacuumDistributionManifold-1-6-7",
        placeholderNames: [
            "Placeholder-TubeBack",
            "Placeholder-TubeFront",
            "Placeholder-TubeLeft1",
            "Placeholder-TubeLeft2",
            "Placeholder-TubeLeft3",
            "Placeholder-TubeRight1",
            "Placeholder-TubeRight2",
            "Placeholder-TubeRight3",
        ],
        type: "distribution-block",
        volume_dm3: 0.017,
    },
    _c[TubeConnectionId.ONE_EIGHT_NINE_DISTRIBUTION_BLOCK] = {
        id: TubeConnectionId.ONE_EIGHT_NINE_DISTRIBUTION_BLOCK,
        translationKey: "sidebar.edit_tube_connection.connection_point_types.".concat(TubeConnectionId.ONE_EIGHT_NINE_DISTRIBUTION_BLOCK),
        modelName: "VacuumDistributionManifold-1-8-9",
        placeholderNames: [
            "Placeholder-TubeBack",
            "Placeholder-TubeFront",
            "Placeholder-TubeLeft1",
            "Placeholder-TubeLeft2",
            "Placeholder-TubeLeft3",
            "Placeholder-TubeLeft4",
            "Placeholder-TubeRight1",
            "Placeholder-TubeRight2",
            "Placeholder-TubeRight3",
            "Placeholder-TubeRight4",
        ],
        type: "distribution-block",
        volume_dm3: 0.023,
    },
    _c[TubeConnectionId.ONE_TEN_ELEVEN_DISTRIBUTION_BLOCK] = {
        id: TubeConnectionId.ONE_TEN_ELEVEN_DISTRIBUTION_BLOCK,
        translationKey: "sidebar.edit_tube_connection.connection_point_types.".concat(TubeConnectionId.ONE_TEN_ELEVEN_DISTRIBUTION_BLOCK),
        modelName: "VacuumDistributionManifold-1-10-11",
        placeholderNames: [
            "Placeholder-TubeBack",
            "Placeholder-TubeFront",
            "Placeholder-TubeLeft1",
            "Placeholder-TubeLeft2",
            "Placeholder-TubeLeft3",
            "Placeholder-TubeLeft4",
            "Placeholder-TubeLeft5",
            "Placeholder-TubeRight1",
            "Placeholder-TubeRight2",
            "Placeholder-TubeRight3",
            "Placeholder-TubeRight4",
            "Placeholder-TubeRight5",
        ],
        type: "distribution-block",
        volume_dm3: 0.028,
    },
    // Last, since the connection type picker lists the models in this order
    _c[TubeConnectionId.TOOL_CHANGER] = {
        id: TubeConnectionId.TOOL_CHANGER,
        translationKey: "sidebar.edit_tube_connection.connection_point_types.tool_changer",
        modelName: "Toolchanger1-1",
        placeholderNames: ["Placeholder-TubeIn01", "Placeholder-TubeOut01"],
        diameterRange: [0.002, 0.02],
        type: "tool-changer",
    },
    _c);
/* FEED PRESSURE POINT*/
export var feedPressurePointModelName = "Regulator";
export var feedPressurePointPlaceholderName = "Placeholder-TubeRight";
export var feedPressurePointEntityName = "FeedPressurePoint";
export var feedPressurePointDefaultX = -0.3;
export var feedPressurePointDefaultZ = -0.6;
export var feedPressurePointNodeId = "feed-pressure-point";
/* TUBE */
export var tubeDefaultLength = 0.5;
export var tubeCylinderAsset = "Primitive-Cylinder10x10cm";
export var tubeMaterials = (_d = {},
    _d[TubeType.VACUUM] = [Material.PLASTIC_GLOSSY_BLUE],
    _d[TubeType.COMPRESSED_AIR] = [
        Material.PLASTIC_GLOSSY_RED,
        Material.PLASTIC_GLOSSY_YELLOW,
    ],
    _d[TubeType.UNKNOWN] = [Material.PLASTIC_MATTE_GREY],
    _d);
export var tubeMaterialsLengthLocked = (_e = {},
    _e[TubeType.VACUUM] = [Material.PLASTIC_GLOSSY_DARK_BLUE],
    _e[TubeType.COMPRESSED_AIR] = [
        Material.PLASTIC_GLOSSY_DARK_RED,
        Material.PLASTIC_GLOSSY_DARK_YELLOW,
    ],
    _e[TubeType.UNKNOWN] = [Material.PLASTIC_GLOSSY_BLACK],
    _e);
/* ATTACHMENT */
export var attachmentModel = "Arrow";
export var attachmentMaterialArea = "MA_Arrow";
export var attachmentMaterials = (_f = {},
    _f[TubeType.VACUUM] = {
        standard: Material.PLASTIC_MATTE_BLUE,
        transparent: Material.TRANSPARENT_BLUE,
    },
    _f[TubeType.COMPRESSED_AIR] = {
        standard: Material.PLASTIC_MATTE_RED,
        transparent: Material.TRANSPARENT_RED,
    },
    _f[TubeType.UNKNOWN] = {
        standard: Material.PLASTIC_MATTE_GREY,
        transparent: Material.TRANSPARENT_GREY,
    },
    _f);
/* VACUUM PUMP */
export var centralizedVacuumPumpDefaultX = 0;
export var centralizedVacuumPumpDefaultZ = -0.5;
export var defaultCentralPumpModel = {
    modelName: "PCS",
    placeholderBack: "Placeholder-TubeBack",
    placeholderFront: "Placeholder-TubeFront",
};
export var centralizedVacuumPumps = {
    PC23S_1: {
        modelName: "PCS",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    PC23S_2: {
        modelName: "PC23S-2",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    PC10X_1: {
        modelName: "PC10X-1",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    PC10X_2: {
        modelName: "PC10X-2",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    ACP: {
        modelName: "ACP",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "PP10X.MC1": {
        modelName: "PP10X-MC1",
        placeholderBack: "Placeholder-TubeBack1",
        placeholderFront: "Placeholder-TubeFront",
    },
    "PP10X.MC2": {
        modelName: "PP10X-MC2",
        placeholderBack: "Placeholder-TubeBack1",
        placeholderFront: "Placeholder-TubeFront",
    },
    "PP23.X": {
        modelName: "PP23-X",
        placeholderBack: "Placeholder-TubeBack1",
        placeholderFront: "Placeholder-TubeFront",
    },
    "PP23.Z": {
        modelName: "PP23-Z",
        placeholderBack: "Placeholder-TubeBack1",
        placeholderFront: "Placeholder-TubeFront",
    },
    P3010x1: {
        modelName: "P3010x1",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    P3010x2: {
        modelName: "P3010x2",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P3010x1-QR": {
        modelName: "P3010x1-QR",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P3010x2-QR": {
        modelName: "P3010x2-QR",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    /* Tacton spelled the quick-release variants with an underscore until Piab
     * were asked to send the model names (above); remove once it no longer
     * does. */
    P3010x1_QR: {
        modelName: "P3010x1-QR",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    P3010x2_QR: {
        modelName: "P3010x2-QR",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    /* The P3010/P5010/P6010 variants, keyed by the cad names Piab were asked
     * to send: the model names themselves. */
    "P3010x1-AVM": {
        modelName: "P3010x1-AVM",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P3010x1-CU": {
        modelName: "P3010x1-CU",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P3010x2-AVM": {
        modelName: "P3010x2-AVM",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P3010x2-CU": {
        modelName: "P3010x2-CU",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P5010-2-x1": {
        modelName: "P5010-2-x1",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P5010-2-x1-AVM": {
        modelName: "P5010-2-x1-AVM",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P5010-2-x1-CU": {
        modelName: "P5010-2-x1-CU",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P5010-2-x2": {
        modelName: "P5010-2-x2",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P5010-2-x2-AVM": {
        modelName: "P5010-2-x2-AVM",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P5010-2-x2-CU": {
        modelName: "P5010-2-x2-CU",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P5010-3-x1": {
        modelName: "P5010-3-x1",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P5010-3-x1-AVM": {
        modelName: "P5010-3-x1-AVM",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P5010-3-x1-CU": {
        modelName: "P5010-3-x1-CU",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P5010-3-x2": {
        modelName: "P5010-3-x2",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P5010-3-x2-AVM": {
        modelName: "P5010-3-x2-AVM",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P5010-3-x2-CU": {
        modelName: "P5010-3-x2-CU",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    P6010: {
        modelName: "P6010",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P6010-AVM": {
        modelName: "P6010-AVM",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "P6010-CU": {
        modelName: "P6010-CU",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    "piClassic_1-2": {
        modelName: "piClassic-1-2",
        placeholderBack: "Placeholder-TubeFront3",
        placeholderFront: "Placeholder-TubeFront",
    },
    "piClassic_3-4": {
        modelName: "piClassic-3-4",
        placeholderBack: "Placeholder-TubeFront3",
        placeholderFront: "Placeholder-TubeFront",
    },
    "piClassic_5-6": {
        modelName: "piClassic-5-6",
        placeholderBack: "Placeholder-TubeFront3",
        placeholderFront: "Placeholder-TubeFront",
    },
    vacuplus_midi_x1: {
        modelName: "Vacuplus-Midi-x1",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    vacuplus_midi_x2: {
        modelName: "Vacuplus-Midi-x2",
        placeholderBack: "Placeholder-TubeTop",
        placeholderFront: "Placeholder-TubeFront",
    },
    /* Vacuum Pump Mini. Tacton reports the article number as `cad_name` for this
     * family, and only offers it for cardboard systems. L7/L14/L28 fell back to
     * the default model between cfd98914 — which dropped the article-number keys
     * when every other family moved to model-name keys — and here. */
    // Vacuum Pump Mini L7
    "0102853": {
        modelName: "Pump-Mini-L7",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    // Vacuum Pump Mini L14
    "0102831": {
        modelName: "Pump-Mini-L14",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    // Vacuum Pump Mini L28
    "0102833": {
        modelName: "Pump-Mini-L28",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    // Vacuum Pump Mini L56
    "0102797": {
        modelName: "0102797",
        placeholderBack: "Placeholder-TubeRight1",
        placeholderFront: "Placeholder-TubeRight2",
    },
    Vacuplus_mini: {
        modelName: "Vacuplus-Mini",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
    single_stage_central_A: {
        modelName: "GenericPump-Centralized01",
        placeholderBack: "Placeholder-TubeBack",
        placeholderFront: "Placeholder-TubeFront",
    },
};
var neoEjectorModels = ["Xi40-Neo", "Si32-Neo", "Pi48-Neo"];
var neoPumpMaterials = {
    "Xi40-Neo": Material.PLASTIC_MATTE_RED,
    "Si32-Neo": Material.PLASTIC_MATTE_BLUE,
    "Pi48-Neo": Material.PLASTIC_MATTE_BLACK,
};
var getNeoPumpKey = function (ejectorCount, ejectorModel, isEnergySavingAvailable) { return "".concat(ejectorModel, "-").concat(ejectorCount).concat(isEnergySavingAvailable ? "-ES" : ""); };
var generateNeoPumps = function () {
    var e_1, _a, e_2, _b;
    var pumps = {};
    var defaultMaterial = Material.PLASTIC_MATTE_GREY;
    try {
        for (var _c = __values([true, false]), _d = _c.next(); !_d.done; _d = _c.next()) {
            var withEnergySaving = _d.value;
            for (var ejectorCount = 1; ejectorCount <= 6; ejectorCount++) {
                try {
                    for (var neoEjectorModels_1 = (e_2 = void 0, __values(neoEjectorModels)), neoEjectorModels_1_1 = neoEjectorModels_1.next(); !neoEjectorModels_1_1.done; neoEjectorModels_1_1 = neoEjectorModels_1.next()) {
                        var ejectorModel = neoEjectorModels_1_1.value;
                        pumps[getNeoPumpKey(ejectorCount, ejectorModel, withEnergySaving)] = {
                            modelName: (ejectorCount > 3 ? "piClassicNeo-Double" : "piClassicNeo-Single") +
                                (withEnergySaving ? "-ES" : ""),
                            placeholderBack: "Placeholder-TubeBack",
                            placeholderFront: "Placeholder-TubeFront",
                            materialTransforms: [
                                {
                                    sourceMaterial: Material.MA_SELECTION_CHOICE_1,
                                    targetMaterial: [1, 3, 4, 6].includes(ejectorCount)
                                        ? neoPumpMaterials[ejectorModel]
                                        : defaultMaterial,
                                },
                                {
                                    sourceMaterial: Material.MA_SELECTION_CHOICE_2,
                                    targetMaterial: [2, 3, 5, 6].includes(ejectorCount)
                                        ? neoPumpMaterials[ejectorModel]
                                        : defaultMaterial,
                                },
                                {
                                    sourceMaterial: Material.MA_SELECTION_CHOICE_3,
                                    targetMaterial: [4, 5, 6].includes(ejectorCount)
                                        ? neoPumpMaterials[ejectorModel]
                                        : defaultMaterial,
                                },
                                {
                                    sourceMaterial: Material.MA_TUBING,
                                    targetMaterial: Material.PLASTIC_GLOSSY_RED,
                                },
                            ],
                        };
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (neoEjectorModels_1_1 && !neoEjectorModels_1_1.done && (_b = neoEjectorModels_1.return)) _b.call(neoEjectorModels_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return pumps;
};
export var neoPumps = generateNeoPumps();
export var getCentralizedVacuumPump = function (vacuumPump) {
    var _a;
    var _b = vacuumPump || {}, cadName = _b.cadName, ejectorCount = _b.ejectorCount, ejectorModel = _b.ejectorModel, isEnergySavingAvailable = _b.isEnergySavingAvailable;
    var isNeoEjector = neoEjectorModels.includes(ejectorModel);
    if (!isNeoEjector) {
        if (!cadName)
            return undefined;
        /* Tacton reports a single cad name for pump families whose 3D model
         * differs per ejector count (e.g. "PC23S" for both PC23S_1 and PC23S_2),
         * so look for a model matching the ejector count before falling back to
         * the cad name on its own. */
        return ((_a = centralizedVacuumPumps["".concat(cadName, "_").concat(ejectorCount)]) !== null && _a !== void 0 ? _a : centralizedVacuumPumps[cadName]);
    }
    var neoPumpKey = ejectorCount &&
        ejectorModel &&
        getNeoPumpKey(ejectorCount, ejectorModel, isEnergySavingAvailable);
    var neoPump = neoPumpKey ? neoPumps[neoPumpKey] : undefined;
    if (!neoPump) {
        console.error("Could not find Neo-pump with key: ".concat(neoPumpKey, " \n\t\t\t\n in list of Neo pumps: "), neoPumps);
    }
    return neoPump;
};
export var defaultDecentralPumpModel = {
    modelName: "PSF",
    placeholderTube: "Placeholder-TubeBack",
};
export var decentralizedVacuumPumps = {
    PISAFE: {
        modelName: "PSF",
        placeholderTube: "Placeholder-TubeBack",
    },
    PIL_AQR: {
        modelName: "PIL-AQR",
        placeholderTube: "Placeholder-TubeBack",
    },
    PIL_EBR: {
        modelName: "PIL-EBR",
        placeholderTube: "Placeholder-TubeBack1",
    },
    PISTAMP: {
        modelName: "piSTAMP",
        placeholderTube: "Placeholder-TubeBack1",
    },
    "piInline Micro": {
        modelName: "piInline-Micro",
        placeholderTube: "Placeholder-TubeBack",
    },
    "piInline Mini": {
        modelName: "piInline-Mini",
        placeholderTube: "Placeholder-TubeBack",
    },
    VGS2010: {
        modelName: "VGS2010",
        placeholderTube: "Placeholder-TubeBack",
    },
    VGS3010: {
        modelName: "VGS3010",
        placeholderTube: "Placeholder-TubeBack",
    },
    "VGS3010-2": {
        modelName: "VGS3010-2",
        placeholderTube: "Placeholder-TubeBack",
    },
    VGS5010: {
        modelName: "VGS5010",
        placeholderTube: "Placeholder-TubeBack",
    },
    VGS4005: {
        modelName: "VGS4005",
        placeholderTube: "Placeholder-TubeBack",
    },
    single_stage_decentral_A: {
        modelName: "GenericPump-Decentralized01",
        placeholderTube: "Placeholder-TubeBack2",
    },
    single_stage_decentral_05: {
        modelName: "GenericPump-DecentralizedInline05",
        placeholderTube: "Placeholder-TubeBack",
    },
    single_stage_decentral_095: {
        modelName: "GenericPump-DecentralizedInline095",
        placeholderTube: "Placeholder-TubeBack",
    },
    "0222882": {
        modelName: "piInline-Micro",
        placeholderTube: "Placeholder-TubeBack",
    },
    "0122896": {
        modelName: "piInline-Mini",
        placeholderTube: "Placeholder-TubeBack",
    },
    "piInline Midi": {
        modelName: "piInline-Midi",
        placeholderTube: "Placeholder-TubeBack",
    },
    "0122899": {
        modelName: "piInline-Midi",
        placeholderTube: "Placeholder-TubeBack",
    },
    Vacuplus_mini: {
        modelName: "Vacuplus-Mini",
        placeholderTube: "Placeholder-TubeBack",
    },
    vacuplus_midi_x1: {
        modelName: "Vacuplus-Midi-x1",
        placeholderTube: "Placeholder-TubeBack",
    },
};
/* The pump product images in `img/app/pumps` are named after the 3D model of
 * the pump, so the image can be resolved from the same cad-name lookups.
 * The generic placeholder models represent a whole range of pumps and
 * therefore have no product image of their own. */
var genericPumpModelNamePrefix = "GenericPump";
export var pumpPlaceholderImage = "img/app/pumps/pump_placeholder.svg";
export var noPumpImage = "img/app/pumps/no_pump.svg";
export var noCupImage = "img/app/cups/no_cup.svg";
export var getVacuumPumpImage = function (vacuumPump) {
    var _a, _b, _c;
    var modelName = (_b = (vacuumPump.cadName
        ? (_a = decentralizedVacuumPumps[vacuumPump.cadName]) === null || _a === void 0 ? void 0 : _a.modelName
        : undefined)) !== null && _b !== void 0 ? _b : (_c = getCentralizedVacuumPump(vacuumPump)) === null || _c === void 0 ? void 0 : _c.modelName;
    if (!modelName || modelName.startsWith(genericPumpModelNamePrefix))
        return pumpPlaceholderImage;
    return "img/app/pumps/".concat(modelName, ".webp");
};
/* CUP MOUNTING AND TUBE CONNECTION IMAGES
 * The thumbnails are named after the 3D model, so they resolve from the same
 * lookups as the assets in the scene. The tube connection images are the 3D
 * artist's product images; the cup mounting images are rendered from the 3D
 * models by `npm run thumbnails:generate` (see README "Component thumbnails"). */
export var cupMountingImageDirectory = "img/app/cup-mountings";
export var tubeConnectionImageDirectory = "img/app/tube-connections";
export var noCupMountingArticleNumber = "no_mounting";
export var noCupMountingImage = "".concat(cupMountingImageDirectory, "/no_mounting.svg");
export var cupMountingPlaceholderImage = "".concat(cupMountingImageDirectory, "/mounting_placeholder.svg");
export var getCupMountingModelImage = function (modelName) {
    return "".concat(cupMountingImageDirectory, "/").concat(modelName, ".webp");
};
/* A mounting without a model of its own (a new Tacton value that is not in
 * `cupMountingModels` yet) falls back to a placeholder rather than a broken
 * image. */
export var getCupMountingImage = function (cupMounting) {
    if (cupMounting.articleNumber === noCupMountingArticleNumber)
        return noCupMountingImage;
    var modelName = cupMountingModels[cupMounting.value];
    return modelName
        ? getCupMountingModelImage(modelName)
        : cupMountingPlaceholderImage;
};
export var getTubeConnectionModelImage = function (modelName) {
    return "".concat(tubeConnectionImageDirectory, "/").concat(modelName, ".webp");
};
export var getTubeConnectionImage = function (type) {
    return getTubeConnectionModelImage(tubeConnectionModels[type].modelName);
};
export var defaultInlineTubeLength = 0.1;
export var defaultInlineTubeDiameter = 0.004;
/* OBJECT */
export var defaultObject = MetalObjectShapeId.ADJUSTABLE_METAL_BOX;
export var objectShapes = __assign(__assign(__assign(__assign({}, metalObjectShapes), glassObjectShapes), plasticObjectShapes), cardboardObjectShapes);
export var objectPosition = {
    x: 0,
    y: 5,
    z: 0,
};
/*
 * Stable id for the cardboard box that every pre-existing (single-object)
 * system is migrated to. Multiple-box support keys boxes by id; this is the
 * id of the "original" box so migrations are deterministic.
 */
export var defaultCardboardBoxId = "cardboard-box-default";
/* Offset (in metres) applied to each newly added box so it doesn't overlap. */
export var newCardboardBoxOffset = { x: 1.5, z: 0 };
/*
 * Default pallet footprint (metres) — a EUR pallet. `length` runs along X,
 * `width` along Z. The pallet is centred at `objectPosition`.
 *
 * Sized together with the default pallet box (400 × 300 mm, see
 * `palletBoxDefaultSize`): the two have to divide reasonably, or every
 * palletizing pattern collapses to the single centred box. This pair fills the
 * pallet with 8 boxes and gives each preset a layout of its own.
 */
export var defaultPalletSize = { length: 1.2, width: 0.8 };
/* Other camera views */
export var screenshotCameraView = {
    x: 0,
    y: 3.8,
    z: 0,
    rotx: 0,
    roty: 90,
    distance: 3.5,
};
